import { useTranslation } from "react-i18next"
import { OPPORTUNITY_DRAG_REORDER_GRID_CLASS } from "../../../lib/opportunity-drag-reorder-grid-classes.js"
import { CreateOpportunitySetCard } from "../../sets/CreateOpportunitySetCard/CreateOpportunitySetCard.js"

export interface OpportunitiesEmptyStateProps {
  onCreateSet?: () => void
  canCreateSet?: boolean
  isCreatingSet?: boolean
  isGenerating?: boolean
}

export function OpportunitiesEmptyState({
  onCreateSet,
  canCreateSet = true,
  isCreatingSet,
  isGenerating,
}: OpportunitiesEmptyStateProps) {
  const { t } = useTranslation()

  return (
    <section className="flex min-w-0 flex-col gap-5 overflow-x-visible pt-6">
      <h2 className="animate-in fade-in slide-in-from-bottom-1 fill-mode-both text-xl font-semibold leading-tight tracking-tight text-balance text-foreground duration-200 motion-reduce:animate-none">
        {t("opportunities.yourSets")}
      </h2>
      <div className={OPPORTUNITY_DRAG_REORDER_GRID_CLASS}>
        <CreateOpportunitySetCard
          onClick={onCreateSet}
          canCreate={canCreateSet}
          isCreatingSet={isCreatingSet}
          isGenerating={isGenerating}
          showAction={!!onCreateSet}
        />
      </div>
    </section>
  )
}
